import { useTranslation } from 'react-i18next';
import ReactPopup from 'reactjs-popup';

import { useCommentUpdateStore } from '../Modals/CommentUpdateStore';
import { useCommentDeleteStore } from '../Modals/CommentDeleteStore';

import comment_icon from 'assets/images/svg/commet_icon.svg';

interface CommentCellProps {
  row: {
    id: number;
    comment: string | null;
  };
  type: string;
}

const CommentCell = ({ row, type }: CommentCellProps) => {
  const { t } = useTranslation();
  const { onCommentUpdateOpen } = useCommentUpdateStore();
  const { onCommentDeleteOpen } = useCommentDeleteStore();

  return (
    <div style={{ width: '100%' }}>
      <div className="d-flex align-items-center justify-content-end gap-1">
        {row.comment ? (
          <div className="d-flex flex-row align-items-center">
            <ReactPopup
              trigger={
                <button
                  title={t('MCTDetail.TrapHistoryCard.modal.viewComment')}
                  type="button"
                  className="btn btn-sm btn-ghost-purple waves-effect waves-light"
                >
                  <img src={comment_icon} width={14} height={14} alt="comment" />
                </button>
              }
              position="top center"
              arrow={false}
            >
              <div
                style={{
                  padding: '10px 16px',
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  minWidth: 120,
                  maxWidth: 300,
                  color: '#333',
                  fontSize: 14,
                }}
              >
                {row.comment}
              </div>
            </ReactPopup>
            <button
              title={t('MCTDetail.TrapHistoryCard.modal.editComment')}
              type="button"
              className="btn btn-sm btn-ghost-purple waves-effect waves-light"
              onClick={() => onCommentUpdateOpen(row, type)}
            >
              <i className="ri-pencil-fill icon icon__edit" />
            </button>
            <button
              title={t('MCTDetail.TrapHistoryCard.modal.deleteComment')}
              type="button"
              className="btn btn-sm btn-ghost-danger waves-effect waves-light"
              onClick={() => onCommentDeleteOpen(row, type)}
            >
              <i className="ri-delete-bin-6-fill icon icon__delete" />
            </button>
          </div>
        ) : (
          <button
            type="button"
            title={t('MCTDetail.TrapHistoryCard.modal.addComment')}
            className="btn btn-sm btn-ghost-purple waves-effect waves-light"
            onClick={() => onCommentUpdateOpen(row, type)}
          >
            <i className="ri-pencil-fill icon icon__edit" />
          </button>
        )}
      </div>
    </div>
  );
};

export default CommentCell;
